import { useEffect, useState } from 'react';
import { FaSync } from 'react-icons/fa';

/**
 * Componente para detectar versiones antiguas y sugerir recarga
 * Muestra un banner cuando detecta que hay una nueva versión
 */
function VersionChecker() {
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);
  const APP_VERSION = '1.0.1'; // Sincronizar con package.json

  useEffect(() => {
    // Verificar versión guardada en localStorage
    const savedVersion = localStorage.getItem('app_version');
    
    if (savedVersion && savedVersion !== APP_VERSION) {
      console.log(`🔄 Nueva versión detectada: ${savedVersion} → ${APP_VERSION}`);
      setShowUpdateBanner(true);
    }
    
    // Guardar versión actual
    localStorage.setItem('app_version', APP_VERSION);
    
    // Verificar cada 5 minutos si hay cambios
    const interval = setInterval(() => {
      const currentVersion = localStorage.getItem('app_version');
      if (currentVersion !== APP_VERSION) {
        setShowUpdateBanner(true);
      }
    }, 5 * 60 * 1000);
    
    return () => clearInterval(interval);
  }, []);

  const handleReload = () => {
    // Forzar recarga completa sin caché
    window.location.reload(true);
  };

  const handleDismiss = () => {
    setShowUpdateBanner(false);
    // Recordar que el usuario rechazó la actualización (por esta sesión)
    sessionStorage.setItem('update_dismissed', 'true');
  };

  if (!showUpdateBanner) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: '#0d6efd',
        color: 'white',
        padding: '12px 20px',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <FaSync style={{ fontSize: '20px' }} />
        <div>
          <strong>Nueva versión disponible</strong>
          <br />
          <small>Por favor, recarga la página para obtener la última versión</small>
        </div>
      </div>
      <div style={{ display: 'flex', gap: '10px' }}>
        <button
          onClick={handleReload}
          style={{
            backgroundColor: 'white',
            color: '#0d6efd',
            border: 'none',
            padding: '8px 16px',
            borderRadius: '4px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          Recargar Ahora
        </button>
        <button
          onClick={handleDismiss}
          style={{
            backgroundColor: 'transparent',
            color: 'white',
            border: '1px solid white',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Más Tarde
        </button>
      </div>
    </div>
  );
}

export default VersionChecker;
